exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".biI1tNmCrsfwlKNNl4QdQ{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n", ""]);

// exports
exports.locals = {
	"ellipsis": "biI1tNmCrsfwlKNNl4QdQ"
};